// extracted by mini-css-extract-plugin
module.exports = {"lazyImage":"JRU0urF","silver":"_2hPCTVi"};